// jshint esversion: 6
import Vue from 'vue';
const test = (el, payload) => el.id === payload.busType;
const createBusTypeRate = (bus, rate) => {
  bus.rateSchemas.push(rate);
  return bus;
};

const updateBusTypeRate = (bus, rate) => {
  bus.rateSchemas.splice(bus.rateSchemas.findIndex(el => el.id === rate.id), 1, rate);
  return bus;
};

const deleteBusTypeRate = (bus, rate) => {
  bus.rateSchemas.splice(bus.rateSchemas.findIndex(el => el.id === rate.id), 1);
  return bus;
}

export default {
  SET_TYPES: (state, payload) => state.types = payload,
  SET_TYPES_MAP: (state, payload) => state.typesMap = payload,
  SET_INDEX_BY_TYPE_MAP: (state, payload) => state.indexByTypeMap = payload,
  SET_RATES_BY_TYPE_MAP: (state, payload) => state.ratesByTypeMap = payload,
  ADD_TYPE: (state, payload) => state.types.push(payload),
  UPDATE_TYPES_MAP: (state, payload) => Vue.set(state.typesMap, payload.id, payload),
  UPDATE_INDEX_BY_TYPES_MAP: (state, payload) => Vue.set(
    state.indexByTypeMap,
    payload.id,
    payload.value
  ),
  UPDATE_RATES_BY_TYPE_MAP: (state, payload) => Vue.set(
    state.ratesByTypeMap,
    payload.id,
    payload.value
  ),
  UPDATE_TYPE: (state, payload) => state.types.splice(
    state.indexByTypeMap[payload.id],
    1,
    payload
  ),
  DELETE_TYPE: (state, payload) => state.types.splice(
    state.indexByTypeMap[payload.id],
    1
  ),
  DELETE_FROM_TYPE_MAP: (state, payload) => Vue.delete(state.typesMap, payload.id),
  DELETE_FROM_INDEX_MAP: (state, payload) => Vue.delete(state.indexByTypeMap, payload.id),
  ADD_RATE: (state, payload) => state.types.splice(
    state.types.findIndex(el => test(el, payload)),
    1,
    createBusTypeRate(state.types.find(el => test(el, payload)), payload)
  ),
  UPDATE_RATE: (state, payload) => state.types.splice(
      state.types.findIndex(el => test(el, payload)),
      1,
      updateBusTypeRate(state.types.find(el => test(el, payload)), payload)
  ),
  DELETE_RATE: (state, payload) => state.types.splice(
    state.types.findIndex(el => test(el, payload)),
    1,
    deleteBusTypeRate(state.types.find(el => test(el, payload)), payload)
  )
};
